export class BookingReminderDTO {
    constructor(
        public id: string,
        public sentDateTime: string,
        public confirmedDateTime: string | null
    ) { }
}
